export const globalMixin = {
  data: () => {
    return {
      // global
      showHeaderMenu: false,
      scrollableElem: null,
      showFooterMenuVisible: false,
      showLpMenuVisible: false
    }
  },
  created: function () {
    this.scrollableElem = document.getElementsByTagName('body')[0]
    this.showFooterMenuVisible = false
    this.showLpMenuVisible = false
  },
  mounted() {
    this.scrollableElem.addEventListener('scroll', this.handleScroll)
  },
  beforeDestroy() {
    this.scrollableElem.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    helloMixin: function () {
      console.log('hello from mixin!')
    },
    handleScroll() {
      const currentUrl = window.location.href;
      const scrollPosition = this.scrollableElem.scrollTop;
      const viewportHeight = window.innerHeight;

      if (!this.showFooterMenuVisible) {
        const ignoreNormalUrls = [
            'public_assistance',
            'diagnose',
            '/lp/',
        ]
        const isIgnore = ignoreNormalUrls.some(url => currentUrl.includes(url));

        this.showFooterMenuVisible = !isIgnore && scrollPosition > viewportHeight;

      }
      if (!this.showLpMenuVisible) {
        const targetLpUrls = [
          '/lp/'
        ]
        const isTarget = targetLpUrls.some(url => currentUrl.includes(url))
        this.showLpMenuVisible = isTarget && scrollPosition > viewportHeight;
      }
    }
  }
}
